module.exports = __webpack_public_path__ + "img/iPhoneHold.2de6e249.svg";